module.exports = "pegasus/assets/triple-card.png";